export const addPaginationInfo = (url: string) => {
  const params = new URLSearchParams(window.location.search)
  const order = params.get("order")
  const column_slug = params.get("column_slug")
  const page = params.get("page") || 1
  const items = params.get("items") || 25

  let mutUrl = `${url}?page=${page}&items=${items}`
  if (order) mutUrl = `${mutUrl}&order=${order}`
  if (column_slug) mutUrl = `${mutUrl}&column_slug=${column_slug}`
  return mutUrl
}

export const addScopeVars = (url, organizationSlug, dataSpaceSlug) => {
  const requestUrl = new URL(url, window.location.origin)

  if (organizationSlug) {
    requestUrl.searchParams.set("organization_id", organizationSlug)
  }

  if (dataSpaceSlug) {
    requestUrl.searchParams.set("data_space_id", dataSpaceSlug)
  }

  return requestUrl.toString()
}

export const addHighlightBlockIds = (url: string, params: URLSearchParams) => {
  let mutUrl = url
  const highlightBlockIds = params.getAll("highlight_block_ids[]")
  const chunkScores = params.getAll("chunk_scores[]")
  const pdfPage = params.get("current_pdf_page")

  if (highlightBlockIds.length) {
    highlightBlockIds.forEach(id => {
      mutUrl += `highlight_block_ids[]=${encodeURIComponent(id)}&`
    })
  }
  if (chunkScores.length) {
    chunkScores.forEach(id => {
      mutUrl += `chunk_scores[]=${id}&`
    })
  }
  if (pdfPage) mutUrl += `current_pdf_page=${pdfPage}`
  return mutUrl
}

export const parseOverrides = (inputFilesOverride: string | undefined) => {
  if (typeof inputFilesOverride === "string") {
    try {
      return JSON.parse(inputFilesOverride || "[]")
    } catch (error) {
      console.error("Failed to parse inputFilesOverride:", error)
      return []
    }
  }
  return inputFilesOverride
}
